export const toTableRowItems = items =>
  items?.map(item => ({
    dsSupportCode: item.dsSupportCode ?? '',
    dsSupportName: item.dsSupportName ?? '',
    supportNumber: item.supportNumber ?? '',
    created: item.created ?? '',
    lastUpdateBy: item.lastUpdateBy ?? ''
  }))
